import Vue from 'vue'

// ref: https://stackoverflow.com/questions/49598541/how-to-modify-the-value-of-v-model-property-via-custom-directive
function handleElemChange(event) {
  event.target.value = event.target.value.trim()
  event.target.dispatchEvent(new CustomEvent('input')) // added this
}

Vue.directive('custom-trim', {
  bind(el, binding, vnode) {
    el.onchange = handleElemChange
  }
})
